"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constant_1 = require("./constant");
var EffectTypes;
(function (EffectTypes) {
    EffectTypes[EffectTypes["FIXED"] = 0] = "FIXED";
    EffectTypes[EffectTypes["SET"] = 1] = "SET";
    EffectTypes[EffectTypes["ADD_RATE"] = 2] = "ADD_RATE";
    EffectTypes[EffectTypes["MAX"] = 3] = "MAX";
    EffectTypes[EffectTypes["MIN"] = 4] = "MIN";
})(EffectTypes = exports.EffectTypes || (exports.EffectTypes = {}));
let buffCounter = 0;
class BuffBuilder {
    constructor(sourceId, owner) {
        this._buff = new Buff(sourceId, owner);
    }
    shield(num) {
        this._buff.shield = num;
        this._buff.params.push(constant_1.BuffParams.SHIELD);
        return this;
    }
    icon(uri) {
        this._buff.icon = uri;
        this._buff.params.push(constant_1.BuffParams.VISIBLE);
        return this;
    }
    probability(probability) {
        this._buff.probability = probability;
        this._buff.params.push(constant_1.BuffParams.SHOULD_COMPUTE_PROBABILITY);
        return this;
    }
    noDispel() {
        this._buff.params.push(constant_1.BuffParams.NO_DISPEL);
        return this;
    }
    noRemove() {
        this._buff.params.push(constant_1.BuffParams.NO_REMOVE);
        return this;
    }
    stamp() {
        this._buff.params.push(constant_1.BuffParams.STAMP);
        this._buff.params.push(constant_1.BuffParams.NO_DISPEL);
        this._buff.params.push(constant_1.BuffParams.NO_REMOVE);
        return this;
    }
    enchantment() {
        this._buff.params.push(constant_1.BuffParams.ENCHANTMENT);
        this._buff.params.push(constant_1.BuffParams.NO_DISPEL);
        this._buff.params.push(constant_1.BuffParams.NO_REMOVE);
        return this;
    }
    fairyland() {
        this._buff.params.push(constant_1.BuffParams.FAIRYLAND);
        this._buff.params.push(constant_1.BuffParams.NO_DISPEL);
        this._buff.params.push(constant_1.BuffParams.NO_REMOVE);
        return this;
    }
    countDown(num) {
        this._buff.countDown = num;
        this._buff.params.push(constant_1.BuffParams.COUNT_DOWN);
        return this;
    }
    countDownBySource(num) {
        this._buff.countDown = num;
        this._buff.params.push(constant_1.BuffParams.COUNT_DOWN_BY_SOURCE);
        return this;
    }
    name(name, maxCount) {
        this._buff.name = name;
        if (typeof maxCount === 'number')
            this._buff.maxCount = maxCount;
        return this;
    }
    control(control) {
        this._buff.control = control;
        this._buff.params.push(constant_1.BuffParams.CONTROL);
        return this;
    }
    buff() {
        this._buff.params.push(constant_1.BuffParams.BUFF);
        return this;
    }
    debuff() {
        this._buff.params.push(constant_1.BuffParams.DEBUFF);
        return this;
    }
    buffAP(propertyName, effectType, value) {
        this._buff.effect = {
            value,
            propertyName,
            effectType
        };
        this._buff.params.push(constant_1.BuffParams.AFFECT_PROPERTY, constant_1.BuffParams.BUFF);
        return this;
    }
    debuffAP(propertyName, effectType, value) {
        this._buff.effect = {
            value,
            propertyName,
            effectType
        };
        this._buff.params.push(constant_1.BuffParams.AFFECT_PROPERTY, constant_1.BuffParams.DEBUFF);
        return this;
    }
    effect(propertyName, effectType, value) {
        this._buff.effect = {
            value,
            propertyName,
            effectType
        };
        this._buff.params.push(constant_1.BuffParams.AFFECT_PROPERTY);
        return this;
    }
    dependOn(buffIdOrEntityId, dependBuffName) {
        if (typeof dependBuffName === 'string') {
            this._buff.dependEntityId = buffIdOrEntityId;
            this._buff.dependBuffName = dependBuffName;
            this._buff.params.push(constant_1.BuffParams.DEPEND_ON);
        }
        else {
            this._buff.dependBuffId = buffIdOrEntityId;
            this._buff.params.push(constant_1.BuffParams.DEPEND_ON);
        }
        return this;
    }
    ruleHighAndDry() {
        this._buff.params.push(constant_1.BuffParams.RULE_HIGH_AND_DRY);
        return this;
    }
    ruleControlImmune() {
        this._buff.params.push(constant_1.BuffParams.RULE_CONTROL_IMMUNE);
        return this;
    }
    end() {
        return this._buff;
    }
}
exports.BuffBuilder = BuffBuilder;
class Buff {
    constructor(sourceId, ownerId) {
        this.name = ''; // buff名称 用于表示相同buff
        this.sourceId = 0; // 来源实体
        this.ownerId = 0;
        this.params = [];
        this.sourceId = sourceId;
        this.ownerId = ownerId;
        this.buffId = ++buffCounter;
    }
    hasParam(p) {
        return this.params.includes(p);
    }
    static build(sourceId, ownerId) {
        return new BuffBuilder(sourceId, ownerId);
    }
}
exports.default = Buff;
